// extracted by mini-css-extract-plugin
export default {"not_found":"NotFound_not_found__hg7Io","box":"NotFound_box__r8Rpg"};